const styles = ({ color }) => ({
  pageFilterAndSort: {
    'justify-content': 'start',
  },
  helpIcon: {
    color: color.primaryButtonBackground,
    marginLeft: 6,
    marginTop: 3,
    height: 16,
    width: 16,
  },
  helpIconContainer: {
    display: 'flex',
  },
});

export default styles;



// WEBPACK FOOTER //
// ./src/pages/Organization/List/styles.js